/*****************************************************************
 *  Layout Events
 * ***************************************************************/

export const WINDOW_RESIZE = "WINDOW_RESIZE"
export const LIVE_TOGGLE= "LIVE_TOGGLE"
export const LIVE_SET_TAB= "LIVE_SET_TAB"
export const CLOSE_LIVE= "CLOSE_LIVE"
export const LIVE_MINIMIZE= "LIVE_MINIMIZE"
